import React, { useState, useEffect } from 'react';
import './BookNow.css';

function BookNow() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    carType: '',
    pickupDate: '',
    dropoffDate: '',
  });

  const [confirmation, setConfirmation] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setIsLoggedIn(true);
    }
  }, []);
  const carOptions = ['Mahindra Major', 'Bolero Camper', 'Scorpio Gateway', 'Scorpio S11 Classic', 'Scorpio-N', 'Thar', 'XUV-500', 'XUV-700', 'Thar-Roxx', 'Safari-Strome', 'Safari', 'Fortuner-Legender', 'Fortuner-Sigma', 'Hilux', 'Endeavour', 'MG-Gloster', 'Force-Gurkha', 'Force-Gurkha 5-Door', 'Force-One', 'Jeep-Grandcherokee', 'Wrangler', 'Pajero'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      alert('You must be logged in to book a car!');
      return;
    }
    setConfirmation(`Thank you, ${formData.name}! Your booking for a ${formData.carType} has been confirmed.`);
    setFormData({
      name: '',
      email: '',
      phone: '',
      carType: '',
      pickupDate: '',
      dropoffDate: '',
    });
  };

  return (
    <div className="car-rental-container">
      <h1 className="car-rental-title">Book a Car</h1>
      {confirmation && <p className="car-rental-confirmation">{confirmation}</p>}
      <form onSubmit={handleSubmit} className="car-rental-form">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="carType">Car Type:</label>
          <select
            id="carType"
            name="carType"
            value={formData.carType}
            onChange={handleChange}
            required
          >
            <option value="">Select a car</option>
            {carOptions.map((car) => (
              <option key={car} value={car}>
                {car}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="pickupDate">Pickup Date:</label>
          <input
            type="date"
            id="pickupDate"
            name="pickupDate"
            value={formData.pickupDate}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="dropoffDate">Dropoff Date:</label>
          <input
            type="date"
            id="dropoffDate"
            name="dropoffDate"
            value={formData.dropoffDate}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="submit-button">Book Now</button>
      </form>
    </div>
  );
}

export default BookNow;
